<template>
  <div class="manual-sync-tab">
    <div class="sync-sections">
      <!-- Contact Synchronization Section -->
      <div class="sync-section">
        <h3>Contact Synchronization</h3>
        <ContactSyncDashboard />
      </div>

      <!-- Job Synchronization Section -->
      <div class="sync-section">
        <h3>Job Synchronization</h3>
        <JobSyncDashboard />
      </div>
    </div>
  </div>
</template>

<script>
import ContactSyncDashboard from './ContactSyncDashboard.vue'
import JobSyncDashboard from './JobSyncDashboard.vue'

export default {
  name: 'ManualSyncTab',
  components: {
    ContactSyncDashboard,
    JobSyncDashboard,
  },
}
</script>

<style scoped>
.manual-sync-tab {
  width: 100%;
  padding: 20px;
}

.sync-sections {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.sync-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.sync-section h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #24ACFE;
  padding-bottom: 10px;
}

.coming-soon {
  padding: 40px;
  text-align: center;
  color: #666;
  font-style: italic;
}
</style>
